/* eslint-disable react/jsx-props-no-spreading */
import { DialogContentText, SvgIconProps } from "@mui/material"
import { ReactElement } from "react"
import { useNavigate } from "react-router-dom"

import { Datasets } from "../../../constants/enums"
import { SINGLE_DEVICE_NAV_LINK } from "../../../router/routes"
import { ApprovalsIcon } from "../../icons/icons"
import { AppCard } from "../../surfaces/appCard"
import SuccessConfirmationTemplate from "../success/successConfirmationTemplate"

interface ConfirmationProps {
    isOpen: boolean
    deviceRef?: string
    dataset: Datasets
}

/**
 * Success dialogue shown when a TTR device is successfully registered
 */
const Confirmation = ({
    isOpen,
    deviceRef,
    dataset,
}: ConfirmationProps): ReactElement => {
    const navigate = useNavigate()

    const viewDevice = (): void => {
        if (deviceRef) {
            navigate(SINGLE_DEVICE_NAV_LINK(dataset, deviceRef))
        }
    }

    const icon = (props: SvgIconProps): ReactElement => (
        <ApprovalsIcon {...props} />
    )

    return (
        <SuccessConfirmationTemplate
            title="Device successfully submitted"
            subtitle="Your device has been passed to our evaluators for review"
            nextButtonTitle="View My Device"
            onClickNext={viewDevice}
            isOpen={isOpen}
            successId={deviceRef}
            successIdName="Device Reference"
            color="success"
            icon={icon}
        >
            <AppCard
                sx={{
                    backgroundColor: "background.contentBackground",
                }}
            >
                <DialogContentText variant="h6">
                    What happens next?
                </DialogContentText>
                <DialogContentText variant="body1">
                    Your device has been assigned a status of Awaiting
                    Assessment. ENA evaluators will review the device and update
                    its status post assessment. You will be notified of this via
                    email
                </DialogContentText>
            </AppCard>
        </SuccessConfirmationTemplate>
    )
}
Confirmation.defaultProps = {
    deviceRef: undefined,
}

export default Confirmation
